var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class PaymentEngineApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'payment';
    }
    getUsageChart(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            var _a, _b;
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/usage`, params: Object.assign(Object.assign({}, params), { accounts: ((_a = params.accounts) === null || _a === void 0 ? void 0 : _a.length) ? params.accounts : undefined, categories: ((_b = params.categories) === null || _b === void 0 ? void 0 : _b.length) ? params.categories : undefined }) }, options));
        });
    }
}
//# sourceMappingURL=index.js.map